<template>
    <nav class="navbar navbar-expand-lg">
        <div class="container-fluid">
            <div>
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <router-link class="home-link" to="/" >                        
                            Globes That Maybe Were
                        </router-link> 
                    </li>
                    <li class="nav-item">
                        <router-link to="/globes">Globes</router-link> 
                    </li>
                    <!----><li class="nav-item">
                        <router-link to="/about">About</router-link> 
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>
  
<script>
export default {
    name: 'NavBar'
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .navbar{
        font-weight:700;
        font-size:24px;
        background:#808080 !important;
        border-bottom:2px solid white;
    }
    .nav-item{
        margin-right:10px;
        font-weight:200;
    }
    .nav-item > *{
        color:white;
        text-decoration: none;
    }
    .nav-item:hover > *{
        text-decoration: underline;
    }
    .home-link{
        font-family: Franklin;
        text-transform: uppercase;
        font-weight:bold;
        color:white;
    }
</style>
  